export default __webpack_public_path__ + "static/media/video_yellow.f679306c.svg";